<template>
    <div class="card_graphic  pb-1 pt-4 pl-4">
        <span class="usedLabel ml-5 px-1">
            {{ periodUsed }}
        </span>
        <span v-if="counterpartUsed != '' && counterpartUsed != 'Todos'" class="usedLabel ml-3 px-1">
            {{ counterpartUsed }}
        </span>
        <div class="content">
            <div class="progressBar">
                <CircularProgressBar :size="112" :progress="localProgress" :stroke-width="40" />
            </div>
            <div class="description">
                <p class="tittleDescription mb-1">{{ tittleCard }}</p>
                <span class="subTittleDescription">
                    <span class="percentage">{{ 100 - localProgress }}% </span> Sin clasificar</span>

                <ul class="pl-0 mt-1 ml-0">
                    <li class="bullet" data-color="red">
                        <span v-if="isMoney" class="textDetail">
                            {{ money(notClassified) }} </span>
                        <span class="textList">Sin clasificar</span>
                        <span v-if="!isMoney">:</span>
                        <span v-if="!isMoney" class="textDetail">
                            {{ notClassified }} </span>
                    </li>
                    <li class="bullet" data-color="green">
                        <span v-if="isMoney" class="textDetail">
                            {{ money(classified) }} </span>
                        <span class="textList">Clasificados</span>
                        <span v-if="!isMoney">:</span>
                        <span v-if="!isMoney" class="textDetail">
                            {{ classified
                            }}
                        </span>
                    </li>
                </ul>
            </div>

        </div>


    </div>

</template>

<script>
import CircularProgressBar from "@/components/generics/CircularProgressBar";
import { parseToMoney } from "@/utils/currency";
export default {
    name: 'CardResumeClassification',
    components: {
        CircularProgressBar,
    },
    props: {
        periodUsed: {
            type: String,
            default: "",
        },
        counterpartUsed: {
            type: String,
            default: "",
        },
        tittleCard: {
            type: String,
            default: ""
        },
        progress: {
            type: Number,
            default: 0,
        },
        classified: {
            type: Number,
            default: 0,
        },
        notClassified: {
            type: Number,
            default: 0
        },
        isMoney: {
            type: Boolean,
            default: false
        },
    },
    methods: {
        money(value) {
            if (value == 0) {
                return '$0'
            } else if (value != "") {
                return parseToMoney(value);
            }
        },
    },
    data() {
        return {
            localProgress: 0
        };
    },
    mounted() {
        this.localProgress = this.progress || 0
    },
    watch: {
        progress() {
            this.localProgress = this.progress || 0
        }
    }
};
</script>
<style lang="scss" scoped>
.card_graphic {
    background-color: #ffffff;

    .usedLabel {
        border: 1px solid #D0D5DD;
        border-radius: 6px;
        padding: 2px 4px;
        justify-content: center;
        align-items: center;
        gap: 3px;

        color: #475467;
        font-size: 14px;
        font-style: normal;
        font-weight: 500;
    }

    .content {
        margin-top: 16px;
        display: flex;
        flex-direction: row;

        .progressBar {
            bottom: 10px;
            flex: 1;
            position: relative;
            display: inline-block;
        }

        .description {
            flex: 3;
            color: #101828;

            .tittleDescription {
                font-size: 16px;
                font-weight: 600;
                line-height: 12px;
                margin: 0px;
            }

            .subTittleDescription {
                font-size: 14px;
                font-weight: 500;
                line-height: 12px;

                .percentage {
                    color: #F56C6C;
                }
            }

            ul {
                list-style: none;

                .bullet {
                    position: relative;
                    padding-left: 16px;

                    color: #475467;
                    font-size: 14px;

                    .textList {
                        font-weight: 400;
                        /* 142.857% */
                    }

                    .textDetail {
                        font-weight: 600;
                    }
                }

                .bullet::before {
                    content: "";
                    position: absolute;
                    left: 0;
                    top: 50%;
                    transform: translateY(-50%);
                    width: 8px;
                    height: 8px;
                    background-color: var(--bullet-color, black);
                    border-radius: 50%;
                }

                /* Cambia el color dinámicamente basado en el atributo data-color */
                .bullet[data-color="red"]::before {
                    background-color: #F56C6C;
                }

                .bullet[data-color="green"]::before {
                    background-color: #04C8C8;
                }
            }


        }
    }

    @media (max-width: 800px) {
        .content {
            flex-direction: column;
            align-items: center;
        }
    }
}
</style>